<nav class="navbar navbar-expand-lg navbar-light bg-light">
  <span class=" mr-auto">
    <button mat-raised-button routerLink="/sites" class="m-1 mr-2">
      <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('sites.plural', 'Sites') }}
    </button>

    @if(parent_site_id) {
      <button mat-raised-button [routerLink]="'/sites/' + parent_site_id + '/children'" class="m-1 mr-2">
        <mat-icon>arrow_back</mat-icon> {{ utils.getLangTerm('child-sites.plural', 'Subsites') }}
      </button>
    }

    @if(site_id && (!isViewMode || canEditSites)) {
      <button mat-raised-button [routerLink]="utils.prepareSiteRelatedLink(site_id, parent_site_id, (isViewMode ? 'edit' : 'view') + '/noticeboard')" class="m-1 mr-2">
        <mat-icon>{{ isViewMode ? 'edit' : 'visibility' }}</mat-icon>
        {{ isViewMode ? 'Edit' : 'View' }}
      </button>
    }
  </span>
</nav>

@if(isViewMode) {
  <app-sites-noticeboard-view></app-sites-noticeboard-view>
} @else {
  <app-sites-noticeboard-edit></app-sites-noticeboard-edit>
}
